<template>

  <div id="page-forms">

    <v-form
      v-model="formdata.valid"
      ref="validateform"
      lazy-validation
    >
      <v-layout
        row
        wrap
      >

        <v-flex
          lg4
          sm4
        >
          <v-text-field
            label="Task Name"
            prepend-icon="tune"
            v-model="formdata.title"
            required
            :rules="formdata.requiredfield"
          ></v-text-field>
        </v-flex>
        <v-flex
          lg2
          sm2
        >
          <v-text-field
            label="From"
            v-model="formdata.addedByUser"
            prepend-icon="person"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          sm2
          lg2
        >
          <v-checkbox
            v-model="formdata.isUrgent"
            label="Is Urgent"
          ></v-checkbox>
        </v-flex>
         <v-flex
          sm2
          lg2
        >

          <v-menu
            :close-on-content-click="false"
            v-model="menudue"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="formdata.dueDate"
              label="Due Date"
              prepend-icon="event"
              readonly
              type="date"
              :value="formattedDate"
            ></v-text-field>
            <v-date-picker
              v-model="formdata.dueDate"
              @input="menudue = false"
            ></v-date-picker>
          </v-menu>

        </v-flex>
        <v-flex
          sm2
          lg2
        >
          <v-checkbox
            v-model="formdata.overDueAllowed"
            label="Overdue not allowed"
            value="True"
          ></v-checkbox>
        </v-flex>
        <v-flex
          sm6
          lg6
        >
          <v-autocomplete
            hint="Atleast 3 Characters required"
            :loading="loader"
            flat
            :items="userItems"
            v-model="formdata.onBehalfID"
            label="On Behalf Of"
            chips
            prepend-icon="people"
            item-text="name"
            item-value="userID"
          > <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeBehalf(data.item)"
              >
                <v-avatar
                  class="primary white--text"
                  v-text="data.item.userName.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item.nickName }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex
          sm6
          lg6
        >

          <v-radio-group
            prepend-icon="verified_user"
            v-model="formdata.followUp"
          >
            <v-radio
              label="Follow up"
              value="true"
            ></v-radio>
            <v-radio
              label="No Follow up"
              value="false"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex
          sm4
          lg4
        >

          <v-autocomplete
            hint="Atleast 3 Characters required"
            :loading="loader"
            flat
            :items="userGroupItems"
            
            label="CC Group"
            chips
            prepend-icon="people"
            item-text="name"
            item-value="userGroupID"
            @change="userGroupCC"
          ></v-autocomplete>
        </v-flex>
        <v-flex
          sm8
          lg8
        >
          <v-autocomplete
            hint="Atleast 3 Characters required"
            :loading="loader"
            :items="userItems"
            v-model="formdata.assignedCC"
            label="CC"
            chips
            multiple
            prepend-icon="person_add"
            item-text="name"
            item-value="userID"
            :close-on-content-click="true"
          >
            <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeCC(data.item)"
              >
                <v-avatar
                  class="primary white--text"
                  v-text="data.item.userName.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item.nickName }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex
          sm4
          lg4
        >

          <v-autocomplete
            hint="Atleast 3 Characters required"
            :loading="loader"
            flat
            :items="userGroupItems"
            label="Assigned To Group"
            chips
            prepend-icon="people"
            item-text="name"
            item-value="userGroupID"
            @change="userGroupTo"
          >

          </v-autocomplete>
        </v-flex>
        <v-flex
          sm8
          lg8
        >

          <v-autocomplete
            hint="Atleast 3 Characters required"
            :loading="loader"
            flat
            :items="userItems"
            v-model="formdata.assignedTo"
            label="Assigned To"
            chips
            multiple
            prepend-icon="perm_identity"
            required
            :rules="formdata.requiredfield"
            item-text="name"
            item-value="userID"
            :close-on-content-click="true"
          >
            <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeTo(data.item)"
              >
                <v-avatar
                  class="primary white--text"
                  v-text="data.item.userName.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item.nickName }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
       
        <v-flex
          sm6
          lg6
        >
          <v-autocomplete
            hint="Atleast 3 Characters required"
            :loading="loader"
            flat
            :items="projectItems"
            v-model="formdata.projectID"
            label="Project"
            chips
            prepend-icon="pages"
            required
            item-text="name"
            item-value="projectID"
            @change="selectProject"
          >
            <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeProject(data.item)"
              >
                <v-avatar
                  class="primary white--text"
                  v-text="data.item.name.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item.name }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex
          sm6
          lg6
        >
          <v-autocomplete
            hint="Atleast 3 Characters required"
            :loading="loader"
            flat
            :items="tagItems"
            v-model="formdata.tagIds"
            label="Tag"
            chips
            multiple
            prepend-icon="local_offer"
            item-text="name"
            item-value="tagMasterID"
            :close-on-content-click="true"
          >
            <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeTag(data.item)"
              >
                <v-avatar
                  class="primary white--text"
                  v-text="data.item.name.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item.name }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex
          sm6
          lg6
        >

          <v-combobox
            v-model="formdata.tags"
            :items="PersonaltagItems"
            label="Personal Tag"
            multiple
            prepend-icon="filter_vintage"
          >
            <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removePTag(data.item)"
              >
                <v-avatar
                  class="primary white--text"
                  v-text="data.item.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-combobox>

        </v-flex>
        <v-flex
          sm6
          lg6
        >
          <v-autocomplete
            flat
            :items="taskStatus"
            v-model="formdata.statusCodeID"
            label="Status"
            chips
            prepend-icon="beenhere"
            required
            :rules="formdata.requiredfield"
            item-text="status"
            item-value="statusCodeID"
          >
            <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeStatus(data.item)"
              >
                <v-avatar
                  class="primary white--text"
                  v-text="data.item.status.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item.status }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.status"></v-list-tile-title>
                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex
          lg12
          sm12
        >
          <!-- <v-textarea
            prepend-icon="note_add"
            v-model="formdata.description"
            label="Description"
          >
          </v-textarea> -->
          <p>Task Description</p>
          <!-- <quill-editor
            class="quill"
            :content="formdata.description"
            :options="editorOption"
            v-model="formdata.description"
            aria-placeholder="Main task Content here..."
          >
          </quill-editor> -->

          <!-- <quill-editor
            class="editor-example bubble"
            ref="myTextEditor"
            :content="formdata.description"
            :options="editorOption"
            @change="onEditorChange($event)"
          >
          </quill-editor> -->

          <editor
            v-model="formdata.description"
            :options="editorOptions"
            :html="editorHtml"
            :visible="editorVisible"
            previewStyle="vertical"
            height="500px"
            mode="wysiwyg"
          />

        </v-flex>
        <v-flex
          sm2
          lg2
        >
          <v-btn
            color="primary"
            @click="openUpload"
          >Upload</v-btn>
          <!-- :fileChangedCallback="fileChanged" -->
          <!-- <upload-btn
            :fileChangedCallback="fileChanged"         
            title="Upload your document"
            name="uploadtask"
            uniqueId
          >
            <template slot="icon-left">
              <v-icon
                left
                color="white"
              >attachment</v-icon>
            </template>
          </upload-btn>
          <div class="large-12 medium-12 small-12 cell">
            <div
              v-for="(file, key) in uploadedFiles"
              class="file-listing"
            >{{ file.name }}
              <v-btn
                icon
                v-if="!showdownload"
                @click="removeFile( key )"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <v-btn
                icon
                v-if="showdownload"
                @click="downloadFile( key )"
              >
                <v-icon>save_alt</v-icon>
              </v-btn>
            </div>
          </div> -->
        </v-flex>
        <!-- <v-flex
          sm2
          lg2
        >
          <v-btn
            color="primary"
            @click="conversation"
          >Reply</v-btn>
        </v-flex> -->
      </v-layout>

    </v-form>
    </v-dialog>
    <v-dialog
      v-model="uploadFile"
      max-width="700px"
      scrollable
      @close="closeDial"
    >
      <v-card>
        <v-form
          v-model="formdata.valid"
          ref="form"
          lazy-validation
        >
          <v-card-title>
            <span>File Upload</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <p><b>Read & Write</b></p>
            <v-autocomplete
              hint="Atleast 3 Characters required"
              flat
              chips
              multiple
              label="User"
              prepend-icon="persion"
              v-model="formdata.readWriteUserID"
              :items="cCItems"
              item-text="name"
              item-value="userID"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeReadWrite(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.userName.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.nickName }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
            <!-- <v-checkbox
              primary
              label="IS Special File"
              v-model="formdata.isSpecialFile"
            ></v-checkbox> -->
            <p><b>Read Only</b></p>
            <v-autocomplete
              hint="Atleast 3 Characters required"
              flat
              chips
              multiple
              label="User"
              prepend-icon="persion"
              v-model="formdata.readonlyUserID"
              :items="cCItems"
              item-text="name"
              item-value="userID"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="removeReadOnly(data.item)"
                >
                  <v-avatar
                    class="primary white--text"
                    v-text="data.item.userName.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.nickName }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
            <upload-btn
              :fileChangedCallback="fileChanged"
              title="Browse"
              name="uploadtask"
              uniqueId
            >
              <template slot="icon-left">
                <v-icon
                  left
                  color="white"
                >attachment</v-icon>
              </template>
            </upload-btn>
            <div class="large-12 medium-12 small-12 cell">
              <div
                v-for="(file, key) in uploadedFiles"
                class="file-listing"
              >{{ file.name }}
                <v-btn
                  icon
                  v-if="!showdownload"
                  @click="removeFile( key )"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <v-btn
                  icon
                  v-if="showdownload"
                  @click="downloadFile( key )"
                >
                  <v-icon>save_alt</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              outline
              color="primary"
              @click.native="save"
            >Upload</v-btn>
            <v-btn
              outline
              color="primary"
              @click="uploadFile = false"
            >Close</v-btn>

          </v-card-actions>
        </v-form>
      </v-card>
      <!-- <vodal :show="show" animation="rotate" @hide="show = false">
    <div>A vue modal with animations.</div>
      </vodal> -->
    </v-dialog>

  </div>
  <!-- </vue-perfect-scrollbar> -->
</template>

 <script>
import UploadButton from 'vuetify-upload-button';
import Bytes from 'bytes';
import { uploadDocuments, downloadFile, documentUsers, createDocumentAccess, updateDocumentAccess } from '@/api/document';
import { getApplicationUsers, getUsers, getTeamMember, getUserGroups, getTaskSorting, getSubTasksbyStatus, getTaskSearchFilter, getTaskAssigne, completeTask, getTaskMasters, getTaskAttachment, getTaskComments, createTaskComments, getSubTasksId, getProjects, getTagMaster, getPersonalTags, getTaskNotes, getTaskMaster, getDataSubTask, createTaskMaster, updateTaskMaster, createTaskNotes, createPersonalTags, updateTaskNotes, createSubTaskMaster, updateSubTaskMaster, deleteTaskMaster, getTaskLinks, getDataTaskLink, createTaskLinks, updateTaskLink, deleteTaskLink, getUserById } from '@/api/taskMaster';
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// import { quillEditor } from 'vue-quill-editor';
import GlobalMessage from '@/constant'
import moment from 'moment'
//  import format from 'date-fns/format'


import Editor from '@toast-ui/vue-editor/src/editor.vue'





export default {

  components: {
    'upload-btn': UploadButton,

    // quillEditor,
    Editor,

  },

  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 160
    },
    taskAccessPermission: {      assignedCc: [],
      assignedTO: [], onBehalfID: null    },
    documentAccess: {      userIDs: [], assignedRights: [],
      documentID: null, documentAccessID: null    },
    PersonaltagItems: [

    ],
    editorText: 'This is initialValue.',
    editorOptions: {
      hideModeSwitch: true
    },
    editorHtml: '',
    editorVisible: true,
    search: null,
    taskStatus: [
      { status: 'Draft', statusCodeID: 511 },
      { status: 'Assigned', statusCodeID: 512 },
      { status: 'Completed', statusCodeID: 513 },
      { status: 'Cancelled', statusCodeID: 514 },
      { status: 'Closed', statusCodeID: 516 }],

    //personalTags: [{ tagId: 1, tag: 'Demo' }],

    editorOption: {
      // theme: 'bubble',
      // placeholder: "输入任何内容，支持html",
      // modules: {
      //   toolbar: [
      //     ['bold', 'italic', 'underline', 'strike'],
      //     [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      //     [{ 'color': [] }, { 'background': [] }],
      //     [{ 'font': [] }],
      //     [{ 'align': [] }],
      //     ['link', 'image'],
      //     ['clean']
      //   ]
      // }
    },
    menudue: false,
    loader: false,
    size: 'lg',
    view: 'grid',
    folder: false,
    dropUsers: [],
    subtaskfiles: new FormData(),

    uploadFile: false,
    conversationFile: false,
    formdata: {
      valid: false,
      taskID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: [],
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      readonlyUserID: [],
      readWriteUserID: [],
      selAssignedRights: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      tags: [],
      isSpecialFile: true,
      isTemp: true,
      isUrgent: false,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      userGroupID: -1,
      mainTaskId: null,
    },
    defaultData: {
      valid: false,
      taskID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: [],
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      readonlyUserID: [],
      readWriteUserID: [],
      sessionID: null,
      linkID: null,
      tags: [],
      isSpecialFile: true,
      isTemp: true,
      isUrgent: false,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      mainTaskId: null,
      userGroupID: -1,
    },
    dueDate: new Date(),
    tagItems: [],
    projectItems: [],
    userItems: [],
    userCCItems: [],
    userToItems: [],
    userGroupItems: [],
    cCItems: [],
    items: [],
    taskItems: [],
    taskItemLink: [],
    allFiles: [],
    uploadedFiles: [],
    showDownLoad: false,
    editFile: {
      name: '',
      size: '',
      contentType: '',
    },
    height: {
      type: String,
      default: null,
    },
    tasktriggered: false,
  }),
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    computedDateFormattedMomentjs () {
      return this.date ? moment(this.date).format('dd, MM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      return this.date ? format(this.date, 'dd, MM Do YYYY') : ''
    }
  },
  watch: {
    model (val) {
      if (val.length > 5) {
        this.$nextTick(() => this.model.pop())
      }
    },
    uploadFile (val) {
      val || this.closeDial();
    }
  },
  computed: {
    editor () {
      return this.$refs.myTextEditor.quill
    },
    formattedDate () {
      return this.dueDate ? moment(this.dueDate).format('DD/MM/YYYY') : undefined; // Custom format
    },
  },
  mounted () {

  },
  created () {

    window.getApp.$on('SAVE_TASK', () => {
      this.save();
    });
    window.getApp.$on('INITIALIZE_TASK', day => {
      this.dueDate = day;
      this.initialize();
    });

    window.getApp.$on('EDIT_TASK', item => {

      this.initialize();
      this.formdata = item;
      this.showdownload = true;
      this.uploadedFiles = [];
      this.formdata.dueDate = this.formateDate(item.dueDate);
      this.InitilizeTab();
    });

  },
  beforeDestroy () {

  },
  methods: {
    onEditorChange ({ editor, html, text }) {


    },
    inputHandler (date) {
      if (typeof date === 'string')
        date = moment(date).toDate();
      this.isActive = false;
      this.dueDate = date;
    },
    formateDate (string) {
      return string ? new Date(string).toISOString().substr(0, 10) : '';
    },
    removeTag (item) {

      const index = this.formdata.tagIds.indexOf(item.tagMasterID)
      if (index >= 0) this.formdata.tagIds.splice(index, 1)
    },
    removeCC (item) {
      const index = this.formdata.assignedCC.indexOf(item.userID)
      if (index >= 0) this.formdata.assignedCC.splice(index, 1)
    },
    removeReadOnly (item) {
      const index = this.formdata.readonlyUserID.indexOf(item.userID)
      if (index >= 0) this.formdata.readonlyUserID.splice(index, 1)
    },

    removeReadWrite (item) {
      const index = this.formdata.readWriteUserID.indexOf(item.userID)
      if (index >= 0) this.formdata.readWriteUserID.splice(index, 1)
    },
    removeTo (item) {
      const index = this.formdata.assignedTo.indexOf(item.userID)
      if (index >= 0) this.formdata.assignedTo.splice(index, 1)
    },
    removeBehalf (item) {

      this.formdata.onBehalfID = null;
    },
    removeStatus (item) {
      this.formdata.statusCodeID = null;
    },
    removeProject (item) {
      //const index = this.projectItems.indexOf(item)
      this.formdata.projectID = null;
    },
    removePTag (item) {
      const index = this.formdata.personaltagIds.indexOf(item)
      if (index >= 0) this.formdata.personaltagIds.splice(index, 1)
    },
    initialize () {

      this.uploadedFiles = [];
      this.formdata = Object.assign({}, this.defaultData);
      this.formdata.addedByUser = this.$store.state.auth.userName;
      this.loader = true;
      //this.formdata.dueDate = new Date(this.dueDate).toISOString().substr(0, 10);
      getApplicationUsers('')
        .then(response1 => {

          this.userItems = response1.data;
          // this.userCCItems = response1.data;
          //this.userToItems = response1.data;

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getUserGroups('')
        .then(response2 => {
          this.userGroupItems = response2.data;

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      // console.log(this.userGroupItems);
      // getUserById(this.userGroupItems)
      // .then(response3 => {
      //   this.userItems = response3.data;

      //   this.loader = false;

      // })
      // .catch(error => {
      //   this.loader = false;
      //   window.getApp.$emit('APP_API_ERROR', error);
      // });
      getProjects('')
        .then(response4 => {
          this.projectItems = response4.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getTagMaster('')
        .then(response => {
          this.tagItems = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);

        });
      getPersonalTags(-1, this.$store.state.auth.userId)
        .then(response => {
          this.PersonaltagItems = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);

        });

    },
    getAttachments () {
      getTaskAttachment(this.formdata.taskID)
        .then(response => {

          this.editFile.name = response.data[0].fileName;
          this.editFile.contentType = response.data[0].contentType;
          this.editFile.size = response.data[0].fileSize;
          this.showdownload = true;

          this.uploadedFiles.push(this.editFile);
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    openUpload () {
      this.taskAccessPermission.assignedCc = this.formdata.assignedCC;
      this.taskAccessPermission.assignedTO = this.formdata.assignedTo;

      this.uploadFile = true;
      // this.cCItems.push(this.formdata.userItems);
      // this.cCItems.push(this.formdata.assignedTo);
      // this.cCItems.push(this.formdata.assignedCC);
      // this.cCItems.push(this.formdata.onBehalfID);
      // this.taskAccessPermission.assignedCc.push(this.formdata.assignedTo);
      if (this.formdata.onBehalfID != 0) {
        this.taskAccessPermission.onBehalfID = this.formdata.onBehalfID;
        // this.taskAccessPermission.assignedCC.push(this.formdata.onBehalfID);
      }

      getUsers(this.taskAccessPermission)
        .then(response1 => {
          this.cCItems = response1.data;

          //this.$refs.reftaskfiles.taskAccessPermission.onBehalfID = this.taskAccessPermission.onBehalfID;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    conversation () {
      window.getApp.$emit('TAB_CONVERSATION');


    },
    getuser () {

    },

    userGroupCC (value) {
      this.loader = true;
      getUserById(value)
        .then(response3 => {
          this.userCCItems = response3.data;
          // console.log(this.userCCItems);
          this.formdata.assignedCC = [];
          for (var id in this.userCCItems) {
            this.formdata.assignedCC.push(this.userCCItems[id].userID);
          }

          // console.log(this.formdata.assignedCC)

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    userGroupTo (value) {
      this.loader=true;
      getUserById(value)
        .then(response4 => {
          this.userToItems = response4.data;
         this.formdata.assignedTo=[];
          for(var id in this.userToItems)
          {
          this.formdata.assignedTo.push(this.userToItems[id].userID);
          }
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    fileChanged (file) {

      this.uploadedFiles.push(file);
      this.showdownload = false;
      this.loader = true;
      this.subtaskfiles.append("file", file, file.name);
      uploadDocuments(this.subtaskfiles)
        .then(response => {
          this.formdata.sessionID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    removeFile (key) {
      this.uploadedFiles.splice(key, 1);
    },
    isImage (file) {
      return this.imageMime.includes(file.fileType);
    },
    mimeIcons (file) {
      return this.imageMime.includes(file.fileType)
        ? 'image'
        : 'insert_drive_file';
    },
    showDetail (file) {
      this.editedIndex = this.documents.indexOf(file);
      this.editedItem = Object.assign({}, file);

      documentUsers(this.editedItem.documentID)
        .then(response => {
          this.editedItem.userID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      this.uploadFile = true;
    },
    showFiles (item) {

      this.documents = this.allFiles.filter(f => f.departmentID == item.value);
      this.view = 'list';
    },
    downloadFile (key) {

      this.loader = true;
      downloadFile(this.formdata.attachments[key])
        .then(response => {
          let blob = new Blob([response.data], { type: this.editFile.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editFile.name
          link.click()
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    InitilizeTab () {
      window.getApp.$emit('INITIALIZE_TASKFILE', this.formdata);
      window.getApp.$emit('INITIALIZE_TASKCONVER', this.formdata);
      window.getApp.$emit('INITIALIZE_SUBTASK', this.formdata.taskID);

      window.getApp.$emit('ENABLE_TASKACTION');
    },
    selectProject (value) {
      getTeamMember(value)
        .then(response => {
          this.formdata.assignedCC = [];

          for (var prop in response.data) {
            this.formdata.assignedCC.push(response.data[prop]);
          }
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    saveDocumentAccess () {

      this.loader = true;

      // if (this.documentAccess.documentAccessID > -1) {
      //   this.documentAccess.documentID = this.documentID;
      //  // this.documentAccess.userIDs = this.taskAccessPermission.cCItems;         
      //   updateDocumentAccess(this.documentAccess)
      //     .then(response => {
      //       this.loader = false;
      //       this.actionButton = true;
      //       window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
      //       this.InitilizeTab();

      //     })
      //     .catch(error => {
      //       this.loader = false;
      //       window.getApp.$emit('APP_API_ERROR', error);
      //     });
      // } else {
      this.formdata.documentAccessID = parseInt(Math.random() * 100) + 1024; // mock a id
      this.documentAccess.documentID = this.documentID;
      createDocumentAccess(this.documentAccess)
        .then(response => {
          this.loader = false;
          this.documentAccess = response.data;

          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
          this.InitilizeTab();
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      // }


    },
    save () {
      console.log(this.formdata);
      if (this.$refs.validateform.validate()) {
        this.loader = true;

        if (this.formdata.taskID > -1) {
          this.formdata.modifiedByUserId = this.$store.state.auth.userId;
          this.formdata.modifiedDate = new Date().toISOString().substr(0, 10);
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date().toISOString().substr(0, 10);
          updateTaskMaster(this.formdata)
            .then(response => {
              this.loader = false;
              this.actionButton = true;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
              this.InitilizeTab();

            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          //this.formdata.taskID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date().toISOString().substr(0, 10);
          this.formdata.statusCodeID = 512;
          createTaskMaster(this.formdata)
            .then(response => {
              this.loader = false;
              this.formdata = response.data;
              console.log(this.formdata);
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
              this.InitilizeTab();
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
      else {
        window.getApp.$emit('APP_API_VAL', GlobalMessage.VALIDATE);
      }
    },
    closeDial () {
      confirm('Confirm to close not save')
        .then(result => {

          console.log(result);
        });
      // window.getApp.$emit('APP_API_VAL', 'Confirm to close');
    }
  },
};
</script>
<style lang="stylus" scoped>
.quill {
  height: 250px;
}
</style>


// WEBPACK FOOTER //
// src/pages/task/taskForm.vue